/** @jsx jsx */

import {
  Fragment as _,
  useContext,
  useState,
  cloneElement,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as InteractionContext } from './interactionContext';
import { useDispatch } from 'react-redux';
import { submitToCollect } from 'services/submitToCollect';
import { unlockInteraction } from 'services/unlockInteraction';
import { useScoringQuizzes } from 'services/apiHelpers/useScoringQuizzes';
import { addScormResponseAction } from 'actions/addScormResponseAction';
import { updateScoreAction } from 'actions/updateScoreAction';
import { Report } from 'store/store';
import Modal from 'components/UI/Modal';

type Result = 'correct' | 'incorrect' | 'attempt' | undefined;

const TextEntry = props => {
  const interactionContext = useContext(InteractionContext);

  // const { setShowFeedback } = interactionContext;

  const {
    messageTextColor = '#000',
    messageBorderColor = '#d2dff9',
    messageFontFamily = 'inherit',
    messageFontSize = 16,
    ratingEndpoint,
    collectionKey,
    learnerIdentity,
    reference,
    submissionEmailDestination,
    subject,
    score,
    correctAnswer,
  } = interactionContext.props;

  const { children } = props;

  const [
    _submitBtn_,
    // feedbackSubmitted,
    feedbackNonScoring,
    feedbackScoring,
  ] = children;

  const targetFeedback = score ? feedbackScoring : feedbackNonScoring;
  // console.log({ score, targetFeedback });

  const submitted = unlockInteraction(interactionContext.id, 1);

  const [textAreaStyle, setTextAreaStyle] = useState<{
    height?: number;
    overflow?: string;
  }>({});

  const [isLive, setIsLive] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  const [result, setResult] = useState<Result>(undefined);
  const [hasFocus, setHasFocus] = useState<boolean>(false);

  const scoringQuizzes = useScoringQuizzes();
  const dispatch = useDispatch();

  const message = useRef<string>('');
  const textArea = useRef<HTMLTextAreaElement>(null);
  const textAreaProxy = useRef<HTMLDivElement>(null);

  const updateTextAreaStyle = () => {
    if (!textAreaProxy.current) {
      return;
    }

    const height = textAreaProxy.current.offsetHeight;
    setTextAreaStyle({
      overflow: height < 240 ? 'hidden' : 'auto',
    });
  };

  const submitBtn = cloneElement(children[0], {
    enabled: isLive,
    onSubmit() {
      //
      // console.log(ratingEndpoint, {
      //   key: collectionKey,
      //   rating: undefined,
      //   message: message?.current,
      //   identity: learnerIdentity,
      //   reference,
      // });

      switch (ratingEndpoint) {
        case 'collect': {
          submitToCollect({
            key: collectionKey,
            rating: undefined,
            message: message.current,
            identity: learnerIdentity,
            reference,
          });

          submitted(1);
          break;
        }

        case 'email': {
          location.href = `mailto:${submissionEmailDestination}?${subject &&
            `subject=${encodeURIComponent(subject)}&`}body=${encodeURIComponent(
            message.current
          )}`;

          submitted(1);
          break;
        }

        case 'hosting': {
          dispatch({
            type: 'SUBMIT_FEEDBACK',
            data: {
              key: collectionKey,
              rating: undefined,
              message: message?.current,
              identity: learnerIdentity,
              reference,
            },
          });

          submitted(1);
          break;
        }
      }

      // setIsSubmitted(true);

      //scorm

      if (!score) {
        setShowFeedback(true);

        return;
      }

      const { id } = interactionContext;

      const section = document.querySelector(`#i${id}`) as HTMLElement;

      const chameleonTextElement = section?.querySelector(
        `.chameleon-text p`
      ) as HTMLElement;

      // question might be an image ? get its alt ?
      let question = '';
      if (chameleonTextElement) {
        question = chameleonTextElement.innerText;
      }

      const correctAnswerParsed =
        correctAnswer && correctAnswer.replace(/ /g, '').split(/,/g);

      const isCorrect = correctAnswerParsed.includes(
        message.current.toLowerCase().replace(/ /g, '')
      );
      // message.current.toLowerCase().replace(/ /g, '') === correctAnswer;
      console.log(correctAnswerParsed, isCorrect);

      const action = {
        id,
        type: 'long-fill-in',
        question,
        reportable: 'longfillin',
        // ,
        response: message?.current,
        correct: correctAnswer,
        //message?.current,
        result: isCorrect ? 1 : 0,
      } as Report;

      console.log(JSON.stringify(action, null, 2));
      // dispatch if there's no scoringQuizzes etc
      let shouldDispatch = true;

      if (scoringQuizzes.length) {
        shouldDispatch = false;
      }

      if (shouldDispatch) {
        dispatch(updateScoreAction(id, 1));
        dispatch(addScormResponseAction(action));
      }

      setResult(isCorrect ? 'correct' : 'incorrect');
      setShowFeedback(true);

      submitted(1);
    },
  });

  useEffect(() => {
    if (!textAreaProxy.current) {
      return;
    }

    updateTextAreaStyle();
  }, []);

  useEffect(() => {
    if (isSubmitted) {
      setShowFeedback(true);
    }
  }, [isSubmitted]);

  // console.log(
  //   // textAreaStyle,
  //   // textArea?.current?.scrollHeight,
  //   message?.current
  // );

  const sharedStyles = {
    width: '100%',
    height: '100%',
    maxHeight: 240,
    padding: '5px 5px 5px 20px',
    fontFamily: messageFontFamily,
    fontSize: messageFontSize,
    color: messageTextColor,
  };

  const textAreaProxyHTML = message?.current.replace(/\n/g, '<br>');

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div
        style={{
          position: 'relative',
          maxHeight: sharedStyles.maxHeight,
        }}
      >
        <div
          ref={textAreaProxy}
          style={{
            ...sharedStyles,
            visibility: 'hidden',
            overflow: 'hidden',
          }}
          dangerouslySetInnerHTML={{
            __html: textAreaProxyHTML || '*',
          }}
          aria-hidden="true"
        />

        <textarea
          ref={textArea}
          placeholder="Type your message here..."
          css={css({
            position: 'absolute',
            left: 0,
            top: 0,
            border: 'none',
            outline: 'none',
            resize: 'none',
            ...sharedStyles,
            ...textAreaStyle,

            ':focus': {
              border: 'none !important',
              outline: 'none !important',
              // boxShadow: `0 0 0 1px ${messageTextColor}`,
            },
          })}
          onFocus={() => {
            setHasFocus(true);
          }}
          onBlur={() => {
            setHasFocus(false);
          }}
          onKeyUp={e => {
            updateTextAreaStyle();
            message.current = e.currentTarget.value;
            setIsLive(!!message.current);
          }}
        />
      </div>

      <div
        style={{
          width: '100%',
          height: 1,
          marginTop: 10,
          // border: `${hasFocus ? 2 : 1}px solid ${messageBorderColor}`,
          boxShadow: `0 0 0 ${hasFocus ? 1 : 0}px ${messageBorderColor}`,
          background: messageBorderColor,
          transition: 'box-shadow 0.3s',
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          margin: '20px 0 0 0',
        }}
      >
        {submitBtn}
      </div>

      {showFeedback && (
        <_>
          {score ? (
            cloneElement(feedbackScoring, {
              result,
              showAttemptNumber: false,
              attempt: 1,
              numberOfAttempts: 1,
              navigationBehaviour: {
                correct: false,
                incorrect: true,
              },
              onClose() {
                setShowFeedback(false);
              },
              useMediaInFeedback: true,
            })
          ) : (
            <Modal
              onClose={() => {
                setShowFeedback(false);
              }}
              contentContainerStyles={{
                position: 'absolute',
                width: '100vw',
                maxWidth: '100vw',
                height: '100vh',
                margin: 0,
                padding: 0,
                borderRadius: 0,
              }}
            >
              {cloneElement(feedbackNonScoring, {
                onClose() {
                  console.log('why you no close !?!?');
                  setShowFeedback(false);
                },
              })}
            </Modal>
          )}
        </_>
      )}
    </div>
  );
};

export default TextEntry;
